import EmployeeEmploymentMovementComponents from "../components/EmployeeEmploymentMovement";
import useEmployeeEmploymentMovement from "../hooks/useEmployeeEmploymentMovement";

function EmployeeEmploymentMovement() {
  const employeeEmploymentMovementProps = useEmployeeEmploymentMovement();
  return (
    <EmployeeEmploymentMovementComponents
      {...employeeEmploymentMovementProps}
    />
  );
}

export default EmployeeEmploymentMovement;
